import React, { useState, useEffect } from 'react';
import RailsMenuItem from '~/_base/components/railsMenuItem';
import { RailsMenu } from '~/_base/hooks/useRailsClick';
import { mutate } from 'swr';
import api from '~/_base/constants/api';
import { Menu, Toolbar, Button } from '@mui/material';
import NavigationIcon from '~/_base/components/navigationIcon';
import RailsButton from '~/_base/components/railsButton';
import logger from '~/_base/logger';
import { useToast } from '~/_base/context/toastContext';

const logo = require('~/_svgs/product_logo_long.svg').default;

export default function TopNavigation() {
  const [topNavItems, setTopNavItems] = useState<React.ReactNode>([]);

  useEffect(() => {
    async function getTopNavigationItems() {
      try {
        const response = await api.topNavigation.request();
        const topNavComponents = response.map(menuOrOperation => {
          if ('items' in menuOrOperation) {
            return (
              <TopNavigationMenu
                menu={menuOrOperation}
                key={menuOrOperation.key}
              />
            );
          } else {
            return (
              <RailsButton
                key={menuOrOperation.key}
                operation={menuOrOperation}
                label={menuOrOperation.name}
                buttonProps={{
                  startIcon: (
                    <NavigationIcon type={menuOrOperation.key || 'insights'} />
                  ),
                  style: { marginLeft: 5 },
                }}
              />
            );
          }
        });
        mutate(api.projects.address);
        setTopNavItems(topNavComponents);
      } catch (err) {
        console.error((err as Error).message);
      }
    }

    getTopNavigationItems();
  }, []);
  return (
    <Toolbar>
      <img
        onClick={() => logger.info('Logo clicked')}
        src={logo}
        alt="Workforce Forms"
      />

      <div style={{ flexGrow: 1 }} />
      {topNavItems}
    </Toolbar>
  );
}

function TopNavigationMenu(props: { menu: RailsMenu }) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLAnchorElement | null>(null);
  const hideOnMobile = props.menu.key !== 'account';

  function handleOpenClick(event: React.MouseEvent<HTMLAnchorElement>) {
    logger.info(`Top menu "${props.menu.name}" clicked (opened)`);
    setOpen(true);
    setAnchorEl(event.currentTarget);
  }
  const { successToast } = useToast();

  return (
    <div
      className={
        hideOnMobile
          ? 'ape-top-level-dd-menu hideOnMobile'
          : 'ape-top-level-dd-menu'
      }
    >
      <Button
        data-testid={`top-nav-${props.menu.key}`}
        style={{ marginLeft: 5 }}
        color="inherit"
        key={props.menu.key}
        component="a"
        startIcon={<NavigationIcon type={props.menu.key} />}
        onClick={handleOpenClick}
      >
        <span className="ape-label">{props.menu.name}</span>
      </Button>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={open}
        onClose={() => setOpen(false)}
      >
        {props.menu.items.map(item => (
          <RailsMenuItem
            key={item.name}
            item={item}
            onItemClick={() => {
              logger.info(`Top menu item "${item.name}" clicked`);
              setOpen(false);
            }}
            onSuccess={() => {
              if (item.uri === '/ape_utilities/archive_job') {
                successToast('Starting automatic archiving job');
              }
            }}
          />
        ))}
      </Menu>
    </div>
  );
}
